// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const QuoteIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 65 58" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="m60.883 0 3.66 4.384c-5.337 4.57-9.34 9.142-12.007 13.713-2.592 4.496-3.888 9.067-3.888 13.713v2.36c.076.45.152.937.228 1.462h.572c2.135-.3 3.66-.45 4.574-.45 3.278 0 5.908 1.012 7.89 3.035C63.971 40.24 65 42.938 65 46.31s-1.067 6.182-3.202 8.43C59.664 56.913 56.92 58 53.565 58c-4.193 0-7.776-1.686-10.75-5.058-2.972-3.447-4.46-7.644-4.46-12.59 0-7.268 1.907-14.35 5.719-21.243C47.962 12.139 53.564 5.77 60.883 0ZM22.3 0l3.773 4.384c-5.412 4.57-9.453 9.142-12.121 13.713-2.592 4.496-3.888 9.067-3.888 13.713v2.36c.076.45.152.937.229 1.462h.572c2.134-.3 3.659-.45 4.574-.45 3.354 0 6.022 1.012 8.004 3.035 2.059 2.023 3.088 4.721 3.088 8.093s-1.106 6.182-3.317 8.43C21.08 56.913 18.334 58 14.98 58c-4.117 0-7.661-1.686-10.635-5.058C1.448 49.495 0 45.298 0 40.352 0 33.01 1.906 25.89 5.718 18.997 9.529 12.102 15.056 5.77 22.298 0Z"
			fill="#fff"
			fillOpacity={0.2}
		/>
	</svg>
);
export default QuoteIcon;
